import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  SearchFilterLanguage,
  searchFilterLanguageToString,
  SearchFilterLanguageType,
} from 'src/app/model/search-filters/search-filter-language';

@Component({
  selector: 'gymfinder-search-filter-text',
  templateUrl: './search-filter-text.component.html',
  styleUrls: ['./search-filter-text.component.scss'],
  standalone: false,
})
export class SearchFilterTextComponent {
  @Input()
  languageText: SearchFilterLanguageType;

  @Output()
  languageTextChange = new EventEmitter<SearchFilterLanguageType>();

  languages = Object.values(SearchFilterLanguage);

  public getLanguageTextLabel(language: SearchFilterLanguage): string {
    return searchFilterLanguageToString(language);
  }

  public getLanguageText(language: SearchFilterLanguage): string {
    return this.languageText[language] || '';
  }

  public onTextChange(newValue: string, language: SearchFilterLanguage) {
    this.languageText[language] = newValue;
    this.languageTextChange.emit(this.languageText);
  }
}
